import React from "react";
import ReactDOM from "react-dom";
import {Publications} from "../components/Publications";

export const insertPublications = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="publications"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<Publications />, element);
  });
};
